import React, { useState } from 'react'

import style from '../../styles/components/newsletter/newsletter-page'
import { structure } from '../../styles/global'
import BaseCSS from '../../styles/global/BaseCSS'
import Metadata from '../Metadata'
import UnresetCSS from '../UnresetCSS'
import InputEmail from './InputEmail'
import List from './List'
import SignUp from './SignUp'

import Head from 'next/head'

const Newsletter = ({ newsletters }) => {
  const [newsletterList, setNewsletterList] = useState(newsletters)
  const [email, setEmail] = useState('')
  const [helperText, setHelperText] = useState('')

  const onEmailChange = e => {
    setHelperText('')
    setEmail(e.target.value)
  }

  const onCheckboxChange = title => {
    const updatedList = newsletterList.map(list => (list.title === title ? { ...list, checked: !list.checked } : list))
    setNewsletterList(updatedList)
  }

  return (
    <div className='newsletter-page-container'>
      <Head>
        <title>News 12 Newsletter</title>
      </Head>
      <h1>Newsletter</h1>
      <InputEmail email={email} helperText={helperText} onEmailChange={onEmailChange} />
      <div className='title'>Select Email Preference:</div>
      <List newsletterList={newsletterList} onCheckboxChange={onCheckboxChange} />
      <SignUp email={email} newsletterList={newsletterList} setHelperText={setHelperText} />
      <Metadata
        metadata={{
          title: 'News 12 Newsletter',
          description: 'Sign up for News 12 newsletters and get digital content delivered right to you'
        }}
      />
      <style jsx global>
        {style}
      </style>
      <style jsx global>
        {structure}
      </style>
      <UnresetCSS />
      <BaseCSS />
    </div>
  )
}

export default Newsletter
